import { autoinject } from 'aurelia-framework';
import { QueryFilter } from 'lib/tables/DataFilter';
import { CheckDuplicatePenPipeSDR, PenPipeSDRDto } from 'models/pen/PenPipeSDR';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';

@autoinject
export class PenPipeSDRService extends BaseApiService<PenPipeSDRDto> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, PenPipeSDRDto);
  }

  async getPenPipeSDRs(filters: QueryFilter) {
    return await this.httpClient.execWithResponseMeta<PenPipeSDRDto[]>(`api/pen-pipe-SDR/list${filters.asQueryString}`, {
      method: 'GET',
    });
  }

  async checkDuplicate(data: CheckDuplicatePenPipeSDR) {
    return await this.httpClient.exec<{ IsDuplicate: boolean }>(`api/pen-pipe-SDR/checkDuplicate`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }
}
